import React, { useEffect, useState } from "react";
import { Grid, Loader, Tab, Menu, Label, Icon } from "semantic-ui-react";
import GameList from "./GameList";
import { useStore } from "../../../app/stores/store";
import { observer } from "mobx-react-lite";
import GameFilters from "./GameFilters";
import { PagingParams } from "../../../app/models/Pagination";
import InfiniteScroll from "react-infinite-scroller";
import GameListItemPlaceholder from "./GameListItemPlaceholder";
import { useTranslation } from "react-i18next";
import CourtDashboard from "./CourtDashboard";

export default observer(function GameDashboard() {
    const { gameStore } = useStore();
    const { loadGames, setPagingParams, pagination } = gameStore;
    const { t } = useTranslation();
    const [loadingNext, setLoadingNext] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    function handleGetNext() {
        setLoadingNext(true);
        setPagingParams(new PagingParams(pagination!.currentPage + 1));
        loadGames().then(() => setLoadingNext(false));
    }

    useEffect(() => {
        if (activeTab === 0) {
            gameStore.gameRegistry.clear();
            loadGames();
        }
    }, [loadGames, activeTab]);

    const gameTab = (
        <Grid padded style={{ margin: 0, width: '100%' }}>
            <Grid.Row>
                <Grid.Column width={16}>
                    <GameFilters />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    {gameStore.loadingInitial && !loadingNext ? (
                        <>
                            <GameListItemPlaceholder />
                            <GameListItemPlaceholder />
                        </>
                    ) : (
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={handleGetNext}
                            hasMore={!loadingNext && !!pagination && pagination.currentPage < pagination.totalPages}
                            initialLoad={false}
                            useWindow={true}
                        >
                            <GameList />
                        </InfiniteScroll>
                    )}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Loader active={loadingNext} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );

    const panes = [
        {
            menuItem: (
                <Menu.Item key='games' onClick={() => setActiveTab(0)}>
                    <Icon name='futbol' />
                    {t('dashboard.tabs.games')}
                </Menu.Item>
            ),
            render: () => <Tab.Pane attached={false} style={{ border: 'none', padding: 0, background: 'transparent' }}>
                {gameTab}
            </Tab.Pane>,
        },
        {
            menuItem: (
                <Menu.Item key='courts' onClick={() => setActiveTab(1)}>
                    <Icon name='building' />
                    {t('dashboard.tabs.privateCourts')}
                </Menu.Item>
            ),
            render: () => <Tab.Pane attached={false} style={{ border: 'none', padding: 0, background: 'transparent' }}>
                <CourtDashboard />
            </Tab.Pane>,
        },
    ];

    return (
        <Tab
            menu={{ secondary: true, pointing: true }}
            panes={panes}
            defaultActiveIndex={0}
        />
    );
});